import { Check } from "lucide-react";

/**
 * Inline currency selector that sits inside/beside an amount input.
 * Usage:
 *   <CurrencySelect value={currency} onChange={setCurrency} />
 */
export default function CurrencySelect({ size = "sm" }) {

  return (
    <div className="relative flex-shrink-0">
      <div
        className={`inline-flex items-center gap-1 rounded-lg border border-black/10 bg-white font-mono font-semibold text-[#1C1C1E] ${
          size === "sm" ? "px-2 py-1 text-[11px] h-7" : "px-2.5 py-1.5 text-[12px] h-8"
        }`}
      >
        IDR
        <Check className={`${size === "sm" ? "w-3 h-3" : "w-3.5 h-3.5"} text-[#A87552]`} />
      </div>
    </div>
  );
}
